import React from 'react';
import {useSelector} from 'react-redux';
import {useHistory, useLocation} from 'react-router-dom';
import {getNewsUrlFromLocale} from '../../../utils/path';
import GlobalHeaderView from './GlobalHeaderView';

const canNotGoBackUrls = ['/register-organisation-help', '/register-organisation', '/register-user', '/activate-account', '/update-email', '/global-subcontractors'];

function GlobalHeaderContainer() {
  const history = useHistory();
  const location = useLocation();
  const [organisation, currentLocale] = useSelector(state => [
    state.organisation,
    state.i18n.locale
  ]);
  const [canGoBack, setCanGoBack] = React.useState(false);

  const newsUrl = getNewsUrlFromLocale(currentLocale);
  const isGoBack = (organisation && location.pathname === '/global-dashboard') ||
    (!organisation && location.pathname === '/account');

  const handleLogoClick = () => {
    if (!organisation) {
      if (location.pathname === '/account') {
        history.push('/global-dashboard');
      }

      return;
    }

    if (location.pathname === '/global-dashboard') {
      if (canGoBack) {
        history.goBack();
      } else {
        history.push('/dashboard');
      }

      setCanGoBack(false);
      return;
    }

    setCanGoBack(!canNotGoBackUrls.includes(location.pathname));
    history.push('/global-dashboard');
  };

  return (
    <GlobalHeaderView
      onLogoClick={handleLogoClick}
      isGoBack={isGoBack}
      newsUrl={newsUrl}
    />
  );
}

export default GlobalHeaderContainer;
